export default ({ request }) => ({
  expoInfoListApi(data = {}) {
    return request({
      url: '/digitalCenter/expo/info/list',
      method: 'post',
      data,
    })
  },
  expoInfoDetailApi(data = {}) {
    return request({
      url: '/digitalCenter/expo/info/detail',
      method: 'post',
      data,
    })
  },
  expoInfoDelApi(data = {}) {
    return request({
      url: '/digitalCenter/expo/info/del',
      method: 'post',
      data,
    })
  },
  expoInfoAuditApi(data = {}) {
    return request({
      url: '/digitalCenter/expo/info/audit',
      method: 'post',
      data,
    })
  },
  expoInfoSaveApi(data = {}) {
    return request({
      url: '/digitalCenter/expo/info/save',
      method: 'post',
      data,
    })
  },
  expoInfoChangeDateApi(data = {}) {
    return request({
      url: '/digitalCenter/expo/info/changeDate',
      method: 'post',
      data,
    })
  },
})
